export const FETCH_START = 'fetchStart';
export const FETCH_END = 'fetchEnd';

export const SET_DEALERS = 'setDealers';
export const SET_SHIPPINGS = 'setShippings';
export const SET_SHIPPING_RATES = 'setShippingRates';

export const SET_LINKED_STORES = 'setLinkedStores';
export const SET_LINKED_COMPANIES = 'setLinkedCompanies';

